module.exports = __webpack_public_path__ + "img/zrfg.be66e147.svg";